// Video service packages — warm accent theme (separate from branding).
export const videoPackages = [
    {
        id: "video-house",
        name: "House Project Video",
        priceFrom: 500,
        priceLabel: "$500",
        priceNote: "Starting From",
        category: "Video / Motion",
        tier: 1,
        ribbon: null,
        description:
            "A cinematic roofing or exterior project edit — ready for client portfolios and social.",
        features: [
            "Roofing or Exterior Video Edit",
            "Cinematic Pacing",
            "Color Correction",
            "Text Animation",
            "Clean Export",
            "Social-Ready Formatting",
        ],
        cta: "Get This Edit",
    },
    {
        id: "video-reel",
        name: "Reel Editing Package",
        priceFrom: 500,
        priceLabel: "$500",
        priceNote: "Starting From",
        category: "Video / Motion",
        tier: 2,
        ribbon: "Most Picked",
        description:
            "High-impact vertical reel editing tuned for hook, pacing, and platform performance.",
        features: [
            "Reel Editing",
            "Vertical Formatting",
            "Hook Pacing",
            "Text Overlays",
            "Motion Transitions",
            "Social Media Optimization",
        ],
        cta: "Get This Edit",
    },
    {
        id: "video-podcast",
        name: "Podcast / Documentary Edit",
        priceFrom: 799,
        priceLabel: "$799",
        priceNote: "Starting From · Under 10 min",
        category: "Video / Motion",
        tier: 3,
        ribbon: "Cinematic",
        description:
            "Clean cinematic editing, audio cleanup, and titles for podcasts and short docs. Longer cuts priced on scope.",
        features: [
            "Clean Pacing",
            "Audio Cleanup",
            "Lower Thirds",
            "Cinematic Structure",
            "Title Design",
            "Social Cutdown Option",
        ],
        cta: "Get This Edit",
    },
    {
        id: "video-premium",
        name: "Premium Motion / Advanced Edit",
        priceFrom: 2500,
        priceLabel: "Up to $2,500+",
        priceNote: "Final pricing depends on scope",
        category: "Video / Motion",
        tier: 4,
        ribbon: "Flagship",
        description:
            "Cinematic storytelling with advanced motion graphics, color, and sound direction. For premium brand films and ad campaigns.",
        features: [
            "Cinematic Storytelling",
            "Advanced Motion Graphics",
            "Premium Transitions",
            "Sound Direction",
            "Color Grading",
            "Visual Pacing",
            "Platform-Ready Exports",
        ],
        cta: "Start The Edit",
        flagship: true,
    },
];

export const findVideoPackageByName = (name) => videoPackages.find((p) => p.name === name) || null;
